import { trackEvent } from './track-event'

type Action =
  | 'calendar'
  | 'person selector'
  | 'option'
  | 'choose rooms'
  | 'select room'
  | 'choose beach chair'
  | 'check availability'
  | 'show dates'
  | 'reset password'
  | 'login with email'
  | 'register now'
  | 'show more'
  | 'to checkout'
  | 'to cart'
  | 'open search'
  | 'find beach chair'
  | 'log in'
  | 'forgot password'
  | 'purchase'
  | 'add to cart'
  | 'bundle add to cart'
  | 'newsletter checkout'
  | 'choose bikes'
  | 'show other'
  | 'open calendar - on site'
  | 'open option - on site'
  | 'open person selector - on site'
  | 'choose available date'
  | 'all timeslots'
  | 'show all'
  | 'find out more'
  | 'offer experience'
  | 'learn more - about us'
  | 'open reviews - header'
  | 'all reviews - modal'

type Type =
  | 'rentable'
  | 'experience'
  | 'accommodation'
  | 'beach_chair'
  | 'login'
  | 'checkout'
  | 'pdp - basket overlay'
  | 'log in'
  | 'registration'
  | 'search'
  | 'bundlebox'
  | 'cart'
  | 'reviews'

export type ClickCtaPayload = {
  type?: Type
  selection?: string
}

export function trackClickCta(action: Action, payload?: ClickCtaPayload) {
  trackClickCtaEvent({
    action: `click - ${action}`,
    type: payload?.type,
    selection: payload?.selection,
  })
}

/**
 * Pushes a `click_cta` event. The params the GA4 click_cta tag forwards (and
 * the pay click's own) start as `undefined`, so GTM's data model can't carry a
 * value over from an earlier push (e.g. a pay click's `payment_type` into
 * `click - purchase`). `experiment_id`/`variation_id` are deliberately kept:
 * they come from GrowthBook's `experiment_viewed` and are stable per user.
 */
export function trackClickCtaEvent(payload: { action: string; [key: string]: unknown }) {
  trackEvent({
    event: 'click_cta',
    event_name: 'user_interaction',
    type: undefined,
    location: undefined,
    selection: undefined,
    payment_type: undefined,
    pay_button: undefined,
    invalid_fields: undefined,
    product_types: undefined,
    ...payload,
  })
}
